<div class="flex justify-around items-center min-h-screen bg-[#FDF0D5] flex-row-reverse">
  <div id="banner"
    class="w-[660px] h-[90vh] flex rounded-[30px] bg-[var(--lightGrayPurple)] my-[20px] flex flex-col relative">
    <div class="w-[55%] fosco flex flex-col ml-5 mt-8" id="container1">
      <h5 class="text-white">
        Escolha agora o melhor plano para você
      </h5>
      <span class="text-white">
       Alunos que resolvem questões tiram notas 72% mais altas.
      </span>
    </div>
  </div>
  <div id="login_container"
    class="w-[600px] h-[500px] flex items-center justify-center rounded-md flex flex-col gap-10 bg-[#FDF0D5] h-fit py-[35px]">
    <h5 class="text-center">
      <img src="/assets/logo_blue_dark.svg" alt="Logo" class="w-[250px] mx-auto" />
    </h5>
    <form (ngSubmit)="onSubmit()" class="flex flex-col gap-5 justify-center w-[85%]">
      <div class="grid grid-cols-2 gap-4">
        <input type="text" name="name" placeholder="Digite o seu nome" [(ngModel)]="userData.name" required class="w-full p-2 border rounded-md">
        <input type="email" name="email" placeholder="Digite o seu email" [(ngModel)]="userData.email" required class="w-full p-2 border rounded-md">
        <input type="text" name="phone" placeholder="Digite o seu telefone" [(ngModel)]="userData.phone" required class="w-full p-2 border rounded-md">
        <input type="text" name="address" placeholder="Digite o seu endereço" [(ngModel)]="userData.address" required class="w-full p-2 border rounded-md">
        <input type="text" name="district" placeholder="Digite o seu bairro" [(ngModel)]="userData.district" required class="w-full p-2 border rounded-md">
        <input type="text" name="city" placeholder="Digite a sua cidade" [(ngModel)]="userData.city" required class="w-full p-2 border rounded-md">
        <select name="UF" [(ngModel)]="userData.UF" required class="w-full p-2 border rounded-md">
          <option value="" disabled selected>Selecione o seu estado</option>
          <option value="AC">Acre</option>
          <option value="AL">Alagoas</option>
          <option value="AP">Amapá</option>
          <option value="AM">Amazonas</option>
          <option value="BA">Bahia</option>
          <option value="CE">Ceará</option>
          <option value="DF">Distrito Federal</option>
          <option value="ES">Espírito Santo</option>
          <option value="GO">Goiás</option>
          <option value="MA">Maranhão</option>
          <option value="MT">Mato Grosso</option>
          <option value="MS">Mato Grosso do Sul</option>
          <option value="MG">Minas Gerais</option>
          <option value="PA">Pará</option>
          <option value="PB">Paraíba</option>
          <option value="PR">Paraná</option>
          <option value="PE">Pernambuco</option>
          <option value="PI">Piauí</option>
          <option value="RJ">Rio de Janeiro</option>
          <option value="RN">Rio Grande do Norte</option>
          <option value="RS">Rio Grande do Sul</option>
          <option value="RO">Rondônia</option>
          <option value="RR">Roraima</option>
          <option value="SC">Santa Catarina</option>
          <option value="SP">São Paulo</option>
          <option value="SE">Sergipe</option>
          <option value="TO">Tocantins</option>
        </select>
        <input type="date" name="birth" placeholder="Data de nascimento" [(ngModel)]="userData.birth" required class="w-full p-2 border rounded-md" minlength="11" maxlength="11">
        <input type="password" name="password" placeholder="Crie uma senha" [(ngModel)]="userData.password" required class="w-full p-2 border rounded-md">
        <input type="password" name="confirm_password" placeholder="Confirme a senha" [(ngModel)]="userData.confirmPassword" required class="w-full p-2 border rounded-md">
      </div>
      <div>
        <input type="checkbox" name="confirm" id="confirm" [(ngModel)]="userData.terms" required>
        <a href="" class="text-xs text-gray-500" routerLink="/terms">
          Declaro que li e concordo com os termos de serviço
        </a>
      </div>
      <button type="submit" class="p-2 text-white bg-[var(--lightRed)] rounded-md cursor-pointer">
        {{ isLoading ? 'Carregando...' : 'Cadastrar' }}
      </button>
    </form>
  </div>
</div>